<section class="events-main-wrap" (click)="$event.stopPropagation();" *ngIf="eventsGroupVM && eventsGroupVM.events.length > 0">
  <ng-container *ngFor="let event of eventsGroupVM.events; let i = index">
    <app-event-mobile [pageType]="pageType" [event]="event" [betsAndOutcomes]="betsAndOutcomesForEvents ? betsAndOutcomesForEvents[event.id] : {}" [betTypeGroupingTemplateItems]="selectedBetTypeGroupingTemplateItems"></app-event-mobile>
  </ng-container>
</section>
